import { render, staticRenderFns } from "./CommentPage.vue?vue&type=template&id=2f5ea5ce&scoped=true&"
import script from "./CommentPage.vue?vue&type=script&lang=js&"
export * from "./CommentPage.vue?vue&type=script&lang=js&"
import style0 from "./CommentPage.vue?vue&type=style&index=0&id=2f5ea5ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5ea5ce",
  null
  
)

export default component.exports